{
  "removeButtonLabel": "Entfernen",
  "removeDescription": "Auf „Löschen“ drücken, um das Tag zu entfernen."
}
